import { render, staticRenderFns } from "./consultantReceipt.vue?vue&type=template&id=26919608&scoped=true&"
import script from "./consultantReceipt.vue?vue&type=script&lang=ts&"
export * from "./consultantReceipt.vue?vue&type=script&lang=ts&"
import style0 from "./consultantReceipt.vue?vue&type=style&index=0&id=26919608&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26919608",
  null
  
)

export default component.exports